import { RoomWallHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomWallHeatLossDetailsFormModel';

export type RoomWallHeatLossDetailsResponse = {
  displayIndex: number;
  outsideWallLengthInMetres: number | null;
  additionalWallAreaInMetresSquared: number | null;
  windowAreaInMetresSquared: number | null;
  doorAreaInMetresSquared: number | null;
  externalAirTemperatureInDegreesCelsius: number | null;
};

export const mapRoomWallHeatLossDetailsResponseToFormModel = (
  response: RoomWallHeatLossDetailsResponse,
): RoomWallHeatLossDetailsFormModel => ({
  outsideWallLengthInMetres: response.outsideWallLengthInMetres?.toString() ?? '',
  additionalWallAreaInMetresSquared: response.additionalWallAreaInMetresSquared?.toString() ?? '',
  windowAreaInMetresSquared: response.windowAreaInMetresSquared?.toString() ?? '',
  doorAreaInMetresSquared: response.doorAreaInMetresSquared?.toString() ?? '',
  externalAirTemperatureInDegreesCelsius: response.externalAirTemperatureInDegreesCelsius?.toString() ?? '',
});
